import React from 'react';
import IndustryPageTemplate from '../../components/IndustryPageTemplate';
import SEO from '../../components/SEO';

const BarberShop = () => {
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "How can Local Business Heroes help my barber shop business?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Local Business Heroes helps barber shop businesses capture more leads, automate follow-ups, reduce no-shows, and grow faster. Rated 4.9/5 by 1,200+ UK businesses."
        }
      },
      {
        "@type": "Question",
        "name": "How much does it cost for barber shop businesses?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Plans start at £297/month with a 14-day trial for just £5. Most barber shop businesses see ROI within the first month."
        }
      },
      {
        "@type": "Question",
        "name": "Do I need technical skills to use it?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "No. Local Business Heroes is designed for busy business owners with zero tech experience. Setup takes 5 minutes with UK-based support."
        }
      },
      {
        "@type": "Question",
        "name": "Will it work for my barber shop business?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes. Local Business Heroes is specifically designed for local service businesses like barber shop. Features include appointment scheduling, automated reminders, lead capture, and customer management."
        }
      }
    ]
  };

  const localBusinessSchema = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    "name": "CRM for Barber Shop - Local Business Heroes",
    "applicationCategory": "BusinessApplication",
    "offers": {
      "@type": "Offer",
      "price": "297",
      "priceCurrency": "GBP"
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.9",
      "reviewCount": "1200"
    }
  };

  const breadcrumbs = [
    { name: "Home", url: "/" },
    { name: "Industries", url: "/industries" },
    { name: "Barber Shop CRM", url: "/industries/barber-shop" }
  ];

  const industryData = {
    name: 'Barber Shop',
    title: 'Keep Chairs Full & Build a Base of Weekly Regulars',
    subtitle: 'Automate rebooking, fill last-minute slots, and turn first-time clients into loyal regulars',
    icon: '✂️',
    challenges: [
      'Walk-ins cause unpredictable schedule',
      'Hard to get clients to rebook',
      'Empty chairs during slow times',
      'One-time clients never return',
      'Managing multiple barbers is chaotic'
    ],
    solutions: [
      'Online booking reduces walk-in chaos',
      'Automatic rebook reminders',
      'Dynamic pricing for slow times',
      'Client retention campaigns',
      'Multi-barber schedule management'
    ],
    features: [
      'Client CRM with cut history',
      'Online booking system',
      'Automatic rebook reminders',
      'Waitlist for walk-ins',
      'Multi-barber scheduling',
      'Loyalty program tracking',
      'Photo portfolios',
      'Review automation'
    ],
    results: [
      '80% clients become regulars',
      '95% chair utilization',
      'Book 2 weeks in advance',
      '£3.9K average monthly revenue increase'
    ]
  };

  return (
    <>
      <SEO 
        title="CRM for Barber Shop UK | Marketing Automation | Local Business Heroes"
        description="Rated 4.9/5. CRM and marketing automation for barber shop businesses. Capture more leads, automate follow-up, grow faster. Start £5 trial today."
        keywords="CRM for barber shop UK, barber shop business software, barber shop customer management, barber shop lead generation UK"
        url="/industries/barber-shop"
        schemaMarkup={[faqSchema, localBusinessSchema]}
        breadcrumbs={breadcrumbs}
      />
      <IndustryPageTemplate industry={industryData} />
    </>
  );
};

export default BarberShop;